import React from "react";
import {
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Typography,
} from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import { parseFlag } from "../../../../resources/residuesTypes";

export default function TableMaterials({ materials }) {
  const utils = useSelector((state) => state.utils);
  return (
    <div>
      <Typography variant="h6">Cantidad de material</Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Material</TableCell>
            <TableCell>Kilos</TableCell>
            <TableCell>Planta de disposición</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {materials.map((material, i) => (
            <TableRow key={i}>
              <TableCell>{parseFlag(material.material)}</TableCell>
              <TableCell>{material.quantity} Kg</TableCell>
              <TableCell>{utils.dispositions.dispositions.find(element => element._id ==material.disposition)?utils.dispositions.dispositions.find(element => element._id ==material.disposition).name+ " ("+ utils.dispositions.dispositions.find(element => element._id ==material.disposition).rut+ ")":""}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
